<template>

    <div class="loader" :class="classes"></div>

</template>

<style scoped lang="scss">

    @import "@sass/_variables.scss";

    .loader {
        background: transparent;
        animation: spin .4s linear infinite;
        border: 2px solid transparent;
        border-radius: 50%;
        border-left: 2px solid $color-text;
        border-top: 2px solid $color-text;
    }

    .loader-centered {
        margin: 60px auto;
    }

    .loader-dark {
        border-left-color: $color-text;
        border-top-color: $color-text;
    }
    .loader-white {
        border-left-color: #fff;
        border-top-color: #fff;
    }

    .loader-12, .loader-xs {
        height: 12px;
        width: 12px;
    }
    .loader-16, .loader-sm {
        height: 16px;
        width: 16px;
    }
    .loader-20, .loader-md {
        height: 20px;
        width: 20px;
    }
    .loader-30, .loader-lg {
        height: 30px;
        width: 30px;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

</style>

<script>

export default {

    props: {
        size: {
            type: String,
            default: 'md',
        },
        type: {
            type: String,
            default: 'dark',
        },
        centered: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        classes() {
            return {
                'loader-xs': this.size === 'xs',
                'loader-sm': this.size === 'sm',
                'loader-md': this.size === 'md',
                'loader-lg': this.size === 'lg',
                'loader-dark': this.type === 'dark',
                'loader-white': this.type === 'white',
                'loader-centered': this.centered,
            };
        },

    },

}

</script>